/* globals angular */

var ngModule = angular.module('trends');
var $ = jQuery;

ngModule.directive('fancybox', function () {
    return {
        restrict: 'A',
        scope: true,
        link: function (scope, element) {
            var target = null;
            scope.openBox = function() {
                target = element.attr('href') || target;
                element.removeAttr('href');
                $.fancybox.open({ content: $(target), type: 'html' });
            };
        }
    };
});
